import { Box, Button, CircularProgress, Stack } from "@mui/material";
import { useForm, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { NetworkNodeTabProps } from "../..";
import { SearchIcon } from "../../../../../../../../../../../assets/icons";
import FormSelect from "../../../../../../../../../../../components/forms/FormSelect";
import FormTextField from "../../../../../../../../../../../components/forms/FormTextField";
import { ThemeColors } from "../../../../../../../../../../../theme/themeValues";
import { NodeSearchMap } from "../NodeSearchMap";

type FormValues = {
	code: string;
	nodeType: string;
	zipCode: string;
	city: string;
	country: string;
};

export const NetworkNodeTab = ({
	onSearch,
	loading,
	nodes,
	nodeTypes,
	countries,
	onSelectNode,
}: NetworkNodeTabProps) => {
	const { t } = useTranslation("dataCollection");

	const form = useForm<FormValues>({
		defaultValues: {
			code: "",
			nodeType: "",
			zipCode: "",
			city: "",
			country: "",
		},
	});

	const values = useWatch({
		control: form.control,
	});

	const isEmpty = (v: string) => v === "" || v === null || v === undefined;
	const hasValues = Object.values(values).some((v) => !isEmpty(v));

	const handleSearchNodes = () => {
		if (!hasValues) return;

		onSearch({
			code: values.code || null,
			typeId: values.nodeType ? Number(values.nodeType) : null,
			zipCode: values.zipCode || null,
			city: values.city || null,
			countryCode: values.country || null,
			mode: "network",
		});
	};

	return (
		<Stack spacing={2}>
			<Box
				display="grid"
				gridTemplateColumns={{
					xs: "1fr",
					md: "repeat(5, 1fr) auto",
				}}
				gap={2}
				alignItems="start"
			>
				<FormTextField name="code" disabled={loading} label={t("detail/code")} form={form} fullWidth />
				<FormSelect
					name="nodeType"
					disabled={loading}
					label={t("detail/node type")}
					form={form}
					options={nodeTypes}
				/>
				<FormTextField name="zipCode" disabled={loading} label={t("detail/zip code")} form={form} fullWidth />
				<FormTextField name="city" disabled={loading} label={t("detail/city")} form={form} fullWidth />
				<FormSelect
					name="country"
					disabled={loading}
					label={t("detail/country")}
					form={form}
					options={countries}
				/>
				<Button
					variant="outlined"
					startIcon={
						loading ? (
							<CircularProgress color="primary" size={"18px"} />
						) : (
							<SearchIcon color={!hasValues ? "disabled" : "primary"} />
						)
					}
					onClick={handleSearchNodes}
					disabled={!hasValues}
					color="primary"
					sx={{
						height: 40,
						minHeight: 40,
						width: { xs: "100%", md: "auto" },
						justifySelf: { md: "start" },
						whiteSpace: "nowrap",
						backgroundColor: ThemeColors.LightBackground,
					}}
				>
					{t("detail/search")}
				</Button>
			</Box>

			<NodeSearchMap nodes={nodes} loading={loading} onSelectNode={onSelectNode} />
		</Stack>
	);
};
